<template>
  <div style="padding:1px;">
    <hd></hd>
    <div class="contioner">
        <h1 class="title">丝芙兰</h1>
        <el-row style="margin-bottom:10px;padding-left:20px;">
            <el-col :span="20" v-if="form.level && !mobiletype" style="margin-bottom:20px;" >
                    <div class="all"  >
                        <div @click="clear()">
                            <span class="decoration">Sephora</span>
                            /
                        </div>
                        <div @click="select(item)" v-for="(item,index) in tagUrl" :key="index">
                            <span class="decoration">{{item}}</span>
                            <span v-if="index != tagUrl.length-1">/</span>

                        </div>

                    </div>

                </el-col>
            <el-col :span="4"  class="select" v-if="!mobiletype">
                <el-select class="" v-model="form.price_order" clearable placeholder="排序方式">
                  <el-option
                    v-for="item in sort"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6" class="goodsInfo" v-if="!mobiletype">

                <el-col :span="24">
                    <div class="tag">
                        {{title}}
                    </div>
                    <div class="tagList">
                        <div v-for="(item,index) in tagList" :key="index" @click="serach(item)" v-if="Number(item.number) >0">
                            {{item.name}}
                            <span>{{item.number | numberFilter}}</span>
                        </div>
                    </div>

                </el-col>
                <el-col :span="24" style="margin-top:20px; width: ">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item title="品牌" name="1">
                            <div>
                                <input type="text" class="input" placeholder="Search for brand" v-model="brandInput" @input="brandFilter()">
                            </div>
                            <div class="wall"  v-if="!newBrandList">
                                <el-checkbox-group v-model="checkList" @change="changeCheck">
                                    <el-checkbox :label="item.name" v-for="(item,index) in brandList" :key="index" v-if="Number(item.number) >0">
                                        <div>{{item.name}}</div>
                                        <div class="number">{{item.number | numberFilter}}</div>
                                    </el-checkbox>
                                </el-checkbox-group>

                                <!-- <div class="brandList" v-for="item in brandList" @click="serach('brand',item)">
                                    {{item}}
                                </div> -->
                            </div>
                            <div class="wall" v-if="newBrandList">
                                <el-checkbox-group v-model="checkList" @change="changeCheck" >
                                    <el-checkbox :label="item.name" v-for="(item,index) in newBrandList" :key="index" v-if="Number(item.number) >0">
                                        <div>{{item.name}}</div>
                                        <div class="number">{{item.number | numberFilter}}</div>
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-col>
            <div class="navBar" v-if="mobiletype">
                <div class="buttonGroup">
                    <div class="button" @click="showSort = true"><span class="icon" :class="{isSort:isSort}">↑↓</span>排序</div>
                    <div class="divider"></div>
                    <div class="button" @click="onpenRefine()">
                        <span class="icon">
                            <img src="../../assets/images/refine1.png" alt="" v-if="!isRefine">
                            <img v-if="isRefine" src="data:image/svg+xml;base64,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" alt="">
                        </span>
                        筛选
                    </div>
                </div>
            </div>
            <el-col :span="18" class="goodsList">
                <dd v-if="loading" class="text-center">
                    <Loading></Loading>
                </dd>
                <el-row v-if="!loading" class="goods">
                    <el-col :span="24" v-if="goodList.length == '0'">
                        当前的品牌和分类暂无商品
                    </el-col>
                    <el-col :md="12" :sm="12" :xs="12" :lg="8" v-for="(item,index) in goodList" :key="index">
                        <div class="goodList">
                            <div class="click" @click="getDetail(item)">
                                <div class="goodImg" >
                                    <div class="ImgLoading" v-if="item.showLoading">
                                        <img  src="../../assets/images/bizarro-loader-30x30.gif">
                                    </div>
                                    <!-- <add-products :product="item" :business="business" v-on:success="success" :description='item.description'> -->
                                        <img  :src="item.picture_url" @load="showImg(item)" @error="imgLoadError(item)">
                                    <!-- </add-products> -->
                                </div>

                            <!-- <div>
                                <div class="addCart" >
                                    <add-products :product="item" :business="business" v-on:success="success" :description='item.description'>
                                        <img src="../../ico/addgood.png">
                                        加入购物车
                                    </add-products>
                                </div>
                            </div> -->
                            <div>
                                <div class="goodName brandName">
                                    {{item.brand_name}}
                                </div>
                                <div class="goodName">
                                    {{item.name}}
                                </div>
                            </div>
                            <div>
                                <div class="goodprice" v-if="time > new Date(item.coupon_start.replace(/-/g,'/')).getTime() && time < new Date(item.coupon_end.replace(/-/g,'/')).getTime()">
                                    <div class="mobilePrice">
                                        <del v-if="item.price != '0.00'">
                                            {{item.currency_symbol}}{{item.price}}
                                        </del>
                                        <del v-if="item.price == '0.00'" v-for="(p,index) in item.price_range.split(',')">
                                            {{item.currency_symbol}}{{p}}
                                            <div v-if="index == '0'" style="display:inline-block;">
                                            -&nbsp;
                                            </div>
                                        </del>
                                    </div>
                                    <div class="mobilePrice">
                                        <span v-if="item.discounted_price != '0.00'">
                                            {{item.currency_symbol}}{{item.discounted_price}}
                                        </span>
                                        <span v-if="item.discounted_price == '0.00'" v-for="(p,index) in item.discounted_price_range.split(',')" >
                                            {{item.currency_symbol}}{{p}}
                                            <div v-if="index == '0'" style="display:inline-block;">
                                            -&nbsp;
                                            </div>
                                        </span>
                                    </div>

                                </div>
                                <div v-else>
                                    <div v-if="item.price != '0.00'">
                                        {{item.currency_symbol}}{{item.price}}
                                    </div>
                                    <div v-if="item.price == '0.00'" v-for="(p,index) in item.price_range.split(',')" style="display:inline-block;">
                                        {{item.currency_symbol}}{{p}}
                                        <div v-if="index == '0'" style="display:inline-block;">
                                        -&nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-dialog v-if="completion" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="completion" width="90%" @close="completion = false">
            <div class="text-center redirct">
                <p><i class="ico ico-paysucces completion"></i></p>
                    <h1 style="padding: 60px 0 25px;">加入购物车成功</h1>
                </p>
            </div>
        </el-dialog>
        <el-dialog v-if="showRefine" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="showRefine" width="90%" @close="closeRefine()">
            <h2 style="padding: 10px 0 10px; text-align:center;border-bottom: 1px solid #f0f0f0 !important;">筛选</h2>
            <el-row>
               <el-col :span="24" class="mobile_refine">
                    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                        <el-menu-item index="1" style="width:50%">商品分类</el-menu-item>
                        <el-menu-item index="2" style="width:50%">品牌</el-menu-item>
                    </el-menu>
               </el-col>
               <el-col :span="24">
                   <div class="mobile_tagList" v-if="activeIndex == '1'">
                       <div v-for="(item,index) in tagUrl" :key="index" class="mobie_tag checked">
                           <div v-if="checked">
                              {{item}}
                              <img src="../../assets/images/mobile_close.svg" @click="del(item)">
                           </div>
                        </div>
                        <div v-for="(item,index) in tagList" :key="index" v-if="!lastTag && Number(item.number) >0" @click="check(item)" class="mobie_tag" >
                            {{item.name}}
                        </div>

                    </div>

                    <div class="mobile_tagList" v-if="activeIndex == '2'">
                        <div>
                            <input type="text" class="input" placeholder="Search for brand" v-model="brandInput" @input="brandFilter()">
                        </div>
                         <el-checkbox-group v-model="checkList" @change="brandCheck" v-if="!newBrandList">
                            <el-checkbox :label="item.name" v-for="(item,index) in brandList" :key="index" v-if="Number(item.number) >0"></el-checkbox>
                        </el-checkbox-group>
                        <el-checkbox-group v-model="checkList" @change="brandCheck" v-if="newBrandList">
                            <el-checkbox :label="item.name" v-for="(item,index) in newBrandList" :key="index" v-if="Number(item.number) >0"></el-checkbox>
                        </el-checkbox-group>
                        <!-- <div v-for="item in brandList" @click="checked('brand',item)" class="mobie_tag" >
                            {{item}}
                        </div> -->
                    </div>
               </el-col>
                <el-button class="block" type="primary" @click="submit()" >确 定</el-button>
            </el-row>
        </el-dialog>
        <el-dialog v-if="showSort" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="showSort" width="90%" @close="showSort = false">
            <h2 style="padding: 10px 0 10px; text-align:center;border-bottom: 1px solid #f0f0f0 !important;">排序</h2>
            <div v-for="(item,index) in sort" :key="index" class="sortList" @click="form.price_order = item.value;showSort = false" :class="{selected:form.price_order == item.value}">
                {{item.label}}
                <img v-if="form.price_order == item.value" class="sortImg" width="16" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii04IDEyLjIgMjUuOSAyMC44IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IC04IDEyLjIgMjUuOSAyMC44OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojM0M2RkVEO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSIxNy45LDE0LjQgMTUuOSwxMi4yIDAsMjkgLTUuOSwyNC4yIC04LDI2LjMgMC4yLDMzIDAuNiwzMi41IDAuNywzMi42IAkJIi8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=">
            </div>
        </el-dialog>
    </div>
    <div class="yd-pagination" v-if="goodList && totalCount > form.limit" style="margin-bottom:20px;">
        <el-pagination
          :page-size="form.limit"
          :pager-count="5"
          :current-page.sync="form.page"
          layout="prev, pager, next"
          next-text="下一页"
          prev-text="上一页"
          :total="totalCount">
        </el-pagination>
      </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>

<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import AddProducts from './AddProducts'
import { CURRENCIES } from '../../services/constant'
import mobilefooter from '../../components/mobilefooter'
import Loading from '../../components/Loading'
import errImag from '../../ico/uploadpic@2x.png'
import GlobalDialogs from '../../components/GlobalDialogs'
let _ = require('lodash')
let $ = require('jQuery')

export default {
  name: 'Brands',
  components: {
    hd: hd,
    ft: ft,
    mobilefooter: mobilefooter,
    AddProducts: AddProducts,
    Loading: Loading,
    GlobalDialogs: GlobalDialogs
  },

  data () {
    return {
      form: {
        page: Number(this.$route.query.page) || 1,
        limit: 30,
        tag_name: null,
        brand_name: null,
        price_order: null,
        level: '',
        level_id: null
      },
      tagUrl: [],
      checked: false,
      lastTag: false,
      title: 'Sephora',
      showLoading: true,
      activeNames: '1',
      errorUserPhoto: 'this.src="' + errImag + '"',
      showRefine: false,
      showSort: false,
      loading: true,
      mobiletype: false,
      screenWidth: document.body.clientWidth,
      CURRENCIES: CURRENCIES,
      business_id: '',
      business: {},
      url: null,
      goodList: '',
      time: '',
      website: '',
      completion: false,
      totalCount: null,
      tagList: null,
      brandList: null,
      activeIndex: '1',
      sort: [
        {value: 'asc', label: '价格:从低到高'},
        {value: 'desc', label: '价格:从高到低'}
      ],
      checkList: [],
      tagCheckList: [],
      mobileLevel: [],
      brandInput: null,
      newBrandList: null,
      i: 0, // 计数器,
      isSort: false,
      isRefine: false,
      backTagUrl: [],
      backCheckList: [],
      timer: false,
      keyword: null,
      tag: null
    }
  },
  created () {
    this.tag = this.$route.params.id
    this.keyword = localStorage.getItem('SearchKeyword')
    if (document.body.clientWidth <= 1160) {
      this.mobiletype = true
    }
    this.time = new Date().getTime()
    if (this.$route.query.tag) {
      this.form.tag = this.$route.query.tag
    }
    this.business.id = this.$route.params.id
    // this.getLevelListByBusiness()
    // this.getBrandListByBusiness()
    this.getBusinessID()
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    async getBusinessID () {
      let res = await api.getIDByTag(this, {
        tag: this.tag
      })
      if (res.body.status == 'ok') {
        this.business.id = res.body.result
        this.getBusiness()
        this.getTagFromUrl()
        this.getLevelFromUrl()
        if (!this.$route.query.level && !this.$route.query.brand) {
          this.getGoodList()
          this.getGoodCount()
        }
      }
    },
    getTagFromUrl () {
      if (this.$route.query.tag) {
        this.form.tag = this.$route.query.tag
      }
    },
    getLevelFromUrl () {
      if (this.$route.query.level) {
        if (this.$route.query.level.indexOf(',') > -1) {
          this.tagUrl = this.$route.query.level.split(',')
        } else {
          this.tagUrl = [this.$route.query.level]
        }
        if (this.mobiletype) {
          this.checked = true
        }
        this.form.level = this.tagUrl.join(',')
      } else {
        this.form.level = ''
        this.tagUrl = []
      }
      if (this.$route.query.brand) {
        if (Array.isArray(this.$route.query.brand)) {
          this.checkList = this.$route.query.brand
        } else {
          this.checkList = [this.$route.query.brand]
        }
        this.form.brand_name = this.checkList.join(',')
      }
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
    },
    // getTagListfromLevel () {
    //     console.log(this.tagList)
    //         if(this.tagUrl.length > 0) {
    //             for(let i = 0;i < this.tagUrl.length;i ++){
    //                 for(let item of this.tagList) {
    //                     if(item.name == this.tagUrl[i]){
    //                             if(item.children.length>0){
    //                                 this.tagList = item.children
    //                                 this.title = this.tagUrl[i]
    //                                 this.lastTag = false
    //                             }else{
    //                                 this.lastTag = true
    //                             }

    //                         break
    //                     }
    //                 }
    //             }
    //         }
    //     console.log(this.tagList)

    // },
    async getBusiness () {
      let res = await api.getListByWebsite(this, {
        id: this.business.id
      })
      let business = res.body.result
      this.url = business[0].website
      this.business = {
        name: business[0].name,
        website: extractHostname(business[0].website),
        id: business[0].id,
        logo: business[0].logo
      }
    },
    async getGoodList () {
      this.loading = true
      let params = {
        page: this.form.page,
        limit: this.form.limit,
        tag_name: this.form.tag_name,
        brand_name: this.form.brand_name,
        price_order: this.form.price_order,
        level: this.form.level,
        keyword: this.keyword,
        tag: this.form.tag
      }
      let res = await api.getSephoraGoodList(this, params)
      if (res.body.status == 'ok') {
        this.loading = false
        this.showLoading = true
        this.goodList = res.body.result
        _.each(this.goodList, item => {
          item.showLoading = true
        })
        console.log('goodList', this.goodList)
        if (this.form.level && this.form.brand_name) {
          this.$router.push(
            {
              name: 'Goods',
              path: this.$route.path,
              params: {
                id: this.$route.params.id
              },
              query: {
                page: this.form.page,
                level: this.tagUrl.join(','),
                brand: this.checkList,
                tag: this.form.tag
              }
            }
          )
        } else if (this.form.level && !this.form.brand_name) {
          this.$router.push(
            {
              name: 'Goods',
              path: this.$route.path,
              params: {
                id: this.$route.params.id
              },
              query: {
                page: this.form.page,
                level: this.tagUrl.join(','),
                tag: this.form.tag
              }
            }
          )
        } else if (!this.form.level && this.form.brand_name) {
          this.$router.push(
            {
              name: 'Goods',
              path: this.$route.path,
              params: {
                id: this.$route.params.id
              },
              query: {
                page: this.form.page,
                brand: this.checkList,
                tag: this.form.tag
              }
            }
          )
        } else if (!this.form.level && !this.form.brand_name) {
          this.$router.push(
            {
              name: 'Goods',
              path: this.$route.path,
              params: {
                id: this.$route.params.id
              },
              query: {
                page: this.form.page,
                tag: this.form.tag
              }
            }
          )
        }
        $('.goodName').each(function () {
          $(this).html($(this).html().replace(/&#174;/gi, '<sup>&#174;</sup>'))
        })
      }
    },
    async getGoodCount () {
      this.loading = true
      let params = {
        tag_name: this.form.tag_name,
        brand_name: this.form.brand_name,
        price_order: this.form.price_order,
        level: this.form.level,
        keyword: this.keyword,
        tag: this.form.trueTag
      }
      let res = await api.getSephoraGoodCount(this, params)
      if (res.body.status == 'ok') {
        this.totalCount = Number(res.body.result)
      }
    },
    async getTagList () {
      // this.loading = true

      let res = await api.getSephoraTagList(this)
      if (res.body.status == 'ok') {
        this.tagList = res.body.result
        // this.getTagListfromLevel()
      }
    },
    async getBrandList () {
      // this.loading = true
      let res = await api.getSephoraBrandList(this)
      if (res.body.status == 'ok') {
        this.brandList = res.body.result
        // _.each(res.body.result ,item => {

        // })
      }
    },
    async getLevelListByBusiness () {
      let level
      let brand_name
      if (this.tagUrl.length > 0) {
        level = this.tagUrl.join(',')
      } else {
        level = ''
      }
      if (this.checkList.length > 0) {
        brand_name = this.checkList.join(',')
      } else {
        brand_name = ''
      }
      let params = {
        business_id: this.business.id,
        level: level,
        brand_name: brand_name,
        keyword: this.keyword
      }
      console.log(level)
      let res = await api.getLevelListByBusiness(this, params)
      // let res = await api.getNormalLevelList(thisparams)
      if (res.body.status == 'ok') {
        this.tagList = res.body.result.level_list
        this.lastTag = res.body.result.last_level
        if (!this.lastTag) {
          if (this.tagUrl.length > 0) {
            this.title = this.tagUrl[this.tagUrl.length - 1]
          } else {
            this.title = 'Sephora'
          }
        }
      }
    },
    async getBrandListByBusiness () {
      let level
      let brand_name
      if (this.tagUrl.length > 0) {
        level = this.tagUrl.join(',')
      } else {
        level = ''
      }
      if (this.checkList.length > 0) {
        brand_name = this.checkList.join(',')
      } else {
        brand_name = ''
      }

      let params = {
        business_id: this.business.id,
        level: level,
        // brand_name: brand_name,
        keyword: this.keyword

      }
      let res = await api.getBrandListByBusiness(this, params)
      if (res.body.status == 'ok') {
        this.brandList = res.body.result
      }
    },
    success () {
      this.completion = true
    },
    clear () {
      this.form.level = ''
      this.tagUrl = []
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
    },
    serach (item) {
      console.log(item)
      if (!this.lastTag) {
        this.tagUrl.push(item.name)
      }
      if (this.lastTag) {
        this.tagUrl.splice(this.tagUrl.length - 1, 1, item.name)
      }
      this.form.level = this.tagUrl.join(',')
      // if(item.children) {
      //     this.tagList = item.children
      //     this.lastTag = false
      //     this.title = item.name

      // }else{
      //     this.lastTag = true
      // }
      this.form.page = 1
      console.log('this.form.level', this.form.level)
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
    },
    select (item) {
      console.log(item)
      if (this.tagUrl.indexOf(item) < this.tagUrl.length - 1) {
        let level = ''
        this.title = item
        this.tagUrl.splice(this.tagUrl.indexOf(item) + 1, this.tagUrl.length - 1 - this.tagUrl.indexOf(item))
        this.form.level = this.tagUrl.join(',')
        this.lastTag = false
        console.log(this.form.level)
      } else {
        // this.lastTag = false
      }
      this.form.page = 1
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
      // this.getTagListfromLevel()
    },
    handleSelect (key, keyPath) {
      this.activeIndex = key
    },
    onpenRefine () {
      this.showRefine = true
      if (this.form.level) {
        this.backTagUrl = this.form.level.split(',')
      } else {
        this.backTagUrl = []
      }
      if (this.form.brand_name) {
        this.backCheckList = this.form.brand_name.split(',')
      } else {
        this.backCheckList = []
      }
      this.getLevelListByBusiness()
    },
    closeRefine () {
      this.tagUrl = this.backTagUrl
      this.checkList = this.backCheckList
    },
    check (item) {
      console.log('this.backTagUrl', this.backTagUrl)
      this.tagUrl.push(item.name)
      this.mobileLevel.push(item.name)
      // this.form.level = this.mobileLevel.join(',')
      // this.tagList = item.children
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
      this.checked = true
      this.brandInput = null
      this.newBrandList = null
    },
    del (item) {
      this.tagUrl.splice(this.tagUrl.indexOf(item), this.tagUrl.length - this.tagUrl.indexOf(item))
      this.lastTag = false

      if (this.tagUrl.length == 0) {
        this.checked = false
        this.mobileLevel = []
        // this.form.level = ''
      } else {
        // this.tagList = this.tagCheckList[this.tagCheckList.length-1].tagList

        this.mobileLevel.splice(this.mobileLevel.indexOf(item), this.mobileLevel.length - this.mobileLevel.indexOf(item))
        // this.form.level = this.mobileLevel.join(',')
      }
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
    },
    submit () {
      this.form.level = this.tagUrl.join(',')
      this.form.brand_name = this.checkList.join(',')
      // this.getGoodList()
      // this.getGoodCount()
      this.showRefine = false
      this.form.page = 1
    },
    brandCheck () {
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
    },
    showImg (item) {
      item.showLoading = false
      console.log(item)
      this.$forceUpdate()
    },
    imgLoadError (item) {
      item.showLoading = false
      item.picture_url = this.business.logo
      this.$forceUpdate()
    },
    changeCheck () {
      this.form.page = 1
      this.form.brand_name = this.checkList.join(',')
      this.getLevelListByBusiness()
      this.getBrandListByBusiness()
    },
    brandFilter () {
      if (this.brandInput) {
        let brandList = []
        _.each(this.brandList, item => {
          if (item.name.toUpperCase().indexOf(this.brandInput.toUpperCase()) > -1) {
            brandList.push(item)
          }
        })
        this.newBrandList = brandList
      } else {
        this.newBrandList = null
      }
    },
    getDetail (item) {
      this.$router.push({name: 'Item', params: {id: item.id}})
    }

  },
  beforeRouteLeave (to, from, next) {
    localStorage.removeItem('SearchKeyword')
    next()
  },
  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        console.log(this.screenWidth)
        if (val <= 1160) {
          this.mobiletype = true
        } else {
          this.mobiletype = false
        }
        console.log(this.mobiletype)
        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = tha t.$store.state.canvasWidth
          that.timer = false
        }, 400)
      }
    },
    form: {
      handler: function (val, oldVal) {
        this.getGoodList()
        this.getGoodCount()
        if (val.price_order) {
          this.isSort = true
        } else {
          this.isSort = false
        }
        if (val.level || val.brand_name) {
          this.isRefine = true
        } else {
          this.isRefine = false
        }
      },
      deep: true

    },
    $route (to, from) {
      if (localStorage.getItem('SearchKeyword')) {
        this.keyword = localStorage.getItem('SearchKeyword')
        this.getBusinessID()
      }
      if (!to.query.level) {
        this.form.level = ''
        this.tagUrl = []
        this.getLevelListByBusiness()
        this.lastTag = false
      }
      if (!to.query.brand) {
        this.form.brand_name = null
        this.checkList = []
        this.getBrandListByBusiness()
        //   this.getBrandList()
      }
    }
    // $route(){
    //     console.log(this.$route.query)
    //     let item = this.$route.query
    //     if(item.level){
    //         this.form.level = item.level
    //         if()
    //     }else{
    //         this.form.level = ''
    //     }
    // },

  }
}
function extractHostname (url) {
  url = String(url)
  var hostname
  var protocol = url.match(/.*:\/\//) || []
  protocol = protocol[0] || ''
  var str = hostname
  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2]
  } else {
    hostname = url.split('/')[0]
  }
  // find & remove port number
  hostname = hostname.split(':')[0]
  // find & remove "?"
  hostname = hostname.split('?')[0]
  // if(hostname == 'www.nike.com' || hostname == 'nike.com') {
  //   if(url.indexOf("://") > -1){
  //     if(url.split('/')[2]){
  //       return protocol + hostname
  //     }else{
  //       return protocol + hostname
  //     }

  //   }else{
  //     if(url.split('/')[1]){
  //       str = url.split('/')[1]
  //       return protocol + hostname +'/'+str+'/'
  //     }else{
  //       return protocol + hostname
  //     }
  //   }

  // }
  return protocol + hostname
}
// $(document).ready(function() {
//
// });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .contioner {
        margin: 154px auto 0;
        max-width: 1500px;
        padding: 0 60px;
        .all {

                color: #666;
                cursor: pointer;
                position: relative;
                font-size: 18px;
                // top: -62px;

                div {
                    display: inline-block;
                    // font-size: 18px;
                    color: #686B73;
                }

                .decoration:hover {
                    text-decoration: underline !important;
                }
                span {
                    display: inline-block;
                    margin-right: 5px;
                }

            }
        .title {
            font-size: 24px !important;
            letter-spacing: 0.1px !important;
            margin: 0px !important;
            display: block !important;
            color: #333333 !important;
            font-weight: 500 !important;
            line-height: 29px !important;
            padding:  0 0 36px 0 !important;
            text-align: center !important;
        }
        .select {
            float: right;
        }
        .navBar {
            position: fixed;
            z-index: 997;
            width: 100%;
            bottom: 0px !important;
            margin-bottom: 30px !important;
            .buttonGroup {
                margin: 0 auto;
                height: 40px !important;
                width: 220px !important;
                background-color: black !important;
                border-radius: 4px !important;
                box-shadow: 0 2px 4px 0 rgba(51,51,51,0.2) !important;

                .button {
                    display: inline-block;
                    width: 46%;
                    text-align: center;
                    color: white !important;
                    font-size: 15px !important;
                    margin: auto !important;
                    padding: 12px 15px !important;

                    .icon {
                        color: #fff !important;
                        letter-spacing: -3px !important;
                        margin-right: 5px !important;

                        &.isSort {
                            color: #FF4650 !important;
                        }

                        img {
                            vertical-align: bottom;
                            width: 20px;
                            height: 14px;
                        }
                    }
                }
                .divider {
                    vertical-align: middle;
                    display: inline-block;
                    padding-top: 5px;
                    height: 26px !important;
                    width: 2px !important;
                    -webkit-align-self: center !important;
                    align-self: center !important;
                    border: 1px solid #686B73 !important;
                }
            }
        }
        .goodsInfo{
            padding: 0 20px;

            .tag {
                color: #333333 !important;
                font-size: 16px !important;
                letter-spacing: 0.1px !important;
                white-space: nowrap !important;
                -webkit-flex-grow: 1 !important;
                flex-grow: 1 !important;
                line-height: 24px !important;
            }
            .tagList {
                // max-height: 216px !important;
                // overflow-y: scroll !important;
                width: 300px;

                div {
                    position: relative;
                    padding: 0 10px;
                    line-height: 24px !important;
                    cursor: pointer;
                    color: #666;

                    span {
                        position: absolute;
                        right: 0;
                        top: 0;
                    }
                }
                div:hover {
                    text-decoration: underline !important;
                    span {
                        text-decoration: underline !important;
                    }
                }
            }
            .input {
                height: 30px !important;
                width: 100% !important;
                display: block !important;
                background-color: #FFF !important;
                border: 1px solid #e1e1e1 !important;
                border-radius: 2px !important;
                line-height: 30px !important;
                text-align: left !important;
                padding: 8px 15px;
                margin-bottom: 10px;
            }
            .wall {
                max-height: 216px !important;
                overflow-y: scroll !important;
                .number {
                    display: inline-block;
                    position: absolute;
                    right: 5px;
                    top: 0;
                }
                .brandList {
                    padding: 5px 10px;
                    cursor: pointer;
                    color: #666;
                }
                .brandList:hover {
                    text-decoration: underline !important;
                }
            }
        }

        .goods {
            text-align: center;
            overflow: hidden;
            padding-top: 25px;
            .goodList {
                margin-bottom: 25px;
                height: 260px;
                cursor: pointer;
                padding: 0 20px;
                .click {
                    cursor: pointer;
                }
                .goodImg {
                    display:inline-block;
                    width:135px;
                    height:135px;
                    margin-bottom: 30px;
                    position: relative;
                    overflow: hidden;
                    .ImgLoading {
                        position: absolute;
                        top: 0;
                        left: 0;
                        display:inline-block;
                        background-color: #F3F3F9 !important;
                        height:135px;
                        width:135px;
                        margin-bottom: 21px;
                        img {
                            height: 30px;
                            width: 30px;
                            margin-top: 52px;
                        }
                    }
                    img {
                        // width: 100%;
                        // width: 100%;
                        // position: absolute;
                        // left: 0;
                        // top: 50%;
                        // -webkit-transform: translateY(-50%);
                        // transform: translateY(-50%);
                        height: 135px;
                        width: 135px;
                        object-fit: contain;
                    }
                }
                .addCart {
                    display: inline-block;
                    width: 102px;
                    font-size:14px;
                    color: #666666;
                    margin-bottom: 20px;

                    img {
                        width: 22px;
                        height: 25px;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                .goodName {
                    font-size:16px;
                    color: #333333;
                    margin-bottom: 10px;

                    &.brandName {
                        font-weight: 600;
                        color: #333;
                    }
                }
                .goodprice {
                    .mobilePrice{
                        display: inline-block;
                    }
                    del {
                        color: #B0B4BF;
                        // margin-right: 20px;
                    }
                    span {
                        color: #FF4650;
                    }
                }
            }
        }

        .redirct {
            font-size:24px;
            line-height:33px;
            margin-top: 54px;
            padding-bottom: 70px;

            .completion {
                background-image: url('../../ico/blueSucccess@2x.png');
                background-position: 0 0;
                background-size: contain;
            }
        }

        .mobile_refine {
            background-color: #ebebeb !important;
            .tab {
                height: 50px !important;
                display: block !important;
                border-bottom: 1px solid transparent !important;
                color: #333 !important;
                font-size: 10px !important;
                line-height: 50px !important;
                overflow: hidden !important;
                padding-left: 15px !important;
                text-transform: none !important;
                background-color: #fff !important;
                border-color: #ebebeb !important;
                font-weight: 500 !important;
            }

        }
        .mobile_tagList {
            height: 370px !important;
            overflow-y: scroll !important;
            margin-bottom: 10px;
            .input {
                height: 35px !important;
                width: 100% !important;
                display: block !important;
                background-color: #f5f5f5 !important;
                border: 1px solid #e1e1e1 !important;
                border-radius: 5px !important;
                line-height: 35px !important;
                text-align: center !important;
                padding: 8px 15px;
                font-size: 13px;
                margin-top: 10px;
            }
            .mobie_tag {
                height: 45px !important;
                width: 100% !important;
                display: block !important;
                position: relative !important;
                border-bottom: 1px solid #f0f0f0 !important;
                color: #666 !important;
                font-size: 14px !important;
                font-weight: 400 !important;
                line-height: 50px !important;
                padding-left: 15px !important;
                padding-right: 15px !important;
                background-color: #fafafa;
                &.checked {
                    background-color: #fff !important;
                }

                img {
                    position: absolute !important;
                    right: 15px !important;
                    top: 50% !important;
                    margin-top: -8px !important;
                    height: 16px;
                    width: 16px;
                }
            }
            // .mobie_tag:hover {
            //     background-color: #333;
            // }
        }
        .sortList {
            height: 50px !important;
            width: 100% !important;
            display: block !important;
            position: relative !important;
            border-bottom: 1px solid #f0f0f0 !important;
            color: #666 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            line-height: 50px !important;
            padding-left: 15px !important;
            padding-right: 15px !important;
            &.selected{
                color: #396bf1 !important
            }
            .sortImg {
                position: absolute !important;
                right: 15px !important;
                top: 50% !important;
                margin-top: -8px !important;
            }
        }
    }
    @media screen and (max-width:1024px){
        .contioner {
            padding: 0 0;
            margin: 80px auto 0;
            .goodsList {
                width: 100%;

                .goodName {
                    font-size: 14px !important;
                }
            }
            .select {
                float: none;
                margin: 0 auto;
                width: 200px;
            }

            .goodprice {
                .mobilePrice {
                    display: block;
                }

            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/goods/Goods.vue